import axios from 'axios'

const headers = {
  'Content-Type': 'application/json',
}

export const LoginSimplified = (userName) => axios.post(`/Consumer/LoginSimplified`, { "userName": userName }, { headers: headers })

export const SendEmailConfirmationToken = (cpf, code) => axios.post(`Consumer/CodeAuthForLoginSimplified?cpfCnpj=${cpf}&code=${code}`, { headers: headers })

export const CreatePasswordForSimplified = (data, token) =>
  axios.post(`Consumer/CreatePasswordForSimplified`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

